import PropTypes from 'prop-types'

import Spinner from '../../spinner'
import Typography from '../../typography'
import RawHTML from '../../../common/raw-html'

import {
  CLOSED,
  RUNNING,
  UPCOMMING
} from '../constants'

const Video = ({ webinar, ...attrs }) => {
  if (webinar.transmissionState === UPCOMMING) {
    return <div
      className={'bg-black bg-opacity-50 px-4 pb-4'}>
      <Spinner
        color={'white'}
        message={
          <Typography
            type={'indicator'}
            className={'text-white'}>
            Este evento aún no ha iniciado.
          </Typography>
        } />
    </div>
  }

  if (webinar.transmissionState === RUNNING) {
    return webinar.liveEmbedRaw
      ? <RawHTML html={webinar.liveEmbedRaw} />
      : <div
        className={'bg-black bg-opacity-50 px-4 pb-4'}>
        <Spinner
          color={'white'}
          message={
            <div>
              <Typography
                tag={'div'}
                type={'indicator'}
                className={'text-white text-center mb-2'}>
                Te redijiremos a la sala de transmisión en vivo.
              </Typography>
              <Typography
                tag={'div'}
                type={'indicator'}
                className={'text-white text-center'}>
                Si no se abre una nueva ventana automaticamente, haz click{' '}
                <a
                  className={'text-red-01'}
                  href={webinar.liveUrl}
                  target={'_blank'}
                  rel="noreferrer">
                  aquí
                </a>
              </Typography>
            </div>
          } />
      </div>
  }

  if (webinar.transmissionState === CLOSED) {
    return webinar.recordedVideo
      ? <video
        width="100%"
        height="100%"
        controls
        autoPlay
        poster={webinar.recordedVideo.thumbnail}>
        <source src={webinar.recordedVideo.file} type="video/mp4" />
      </video>
      : webinar.recordedEmbedRaw
        ? <RawHTML html={webinar.liveEmbedRaw} />
        : webinar.recordedVideoUrl
          ? <div
            className={'bg-black bg-opacity-50 px-4 pb-4'}>
            <Spinner
              color={'white'}
              message={
                <div>
                  <Typography
                    tag={'div'}
                    type={'indicator'}
                    className={'text-white text-center mb-2'}>
                    Te redijiremos a la grabacion de la transmission.
                  </Typography>
                  <Typography
                    tag={'div'}
                    type={'indicator'}
                    className={'text-white text-center'}>
                    Si no se abre una nueva ventana automaticamente, haz click{' '}
                    <a
                      className={'text-red-01'}
                      href={webinar.recordedVideoUrl}
                      target={'_blank'}
                      rel="noreferrer">
                      aquí
                    </a>
                  </Typography>
                </div>
              } />
          </div>
          : <div
            className={'bg-black bg-opacity-50 px-4 pb-4'}>
            <Spinner
              color={'white'}
              message={
                <Typography
                  tag={'div'}
                  type={'indicator'}
                  className={'text-white text-center'}>
                  La grabación de esta transmisión aún no está disponible.
                </Typography>
              } />
          </div>
  }

  return <></>
}

Video.propTypes = {
  webinar: PropTypes.object
}

export default Video
